/** Field order on /account/edit (top to bottom). */
const ACCOUNT_EDIT_FIELD_ORDER = [
  'firstName',
  'lastName',
  'sex',
  'birthDate',
  'nationality',
  'passport',
  'birthCountry',
  'placeOfBirth',
  'email',
  'phone',
  'nextOfKinFirstName',
  'nextOfKinLastName',
  'nextOfKinRelationship',
  'nextOfKinPhone',
  'city',
  'country',
  'address',
  'zip'
];

const findFieldElement = fieldName => (
  document.querySelector(`[data-account-edit-field="${fieldName}"]`)
  || document.getElementById(`account-edit-field-${fieldName}`)
  || document.querySelector(`[name="${fieldName}"]`)
);

/**
 * Scroll to the first invalid field on the account edit form.
 *
 * @param {string[]} fieldNames Keys with validation errors
 */
export const scrollToFirstFieldError = fieldNames => {
  if (!fieldNames || fieldNames.length === 0) {
    return;
  }

  const firstField = ACCOUNT_EDIT_FIELD_ORDER.find(name => fieldNames.includes(name)) || fieldNames[0];
  const element = findFieldElement(firstField);

  if (!element) {
    return;
  }

  element.scrollIntoView({ behavior: 'smooth', block: 'center' });

  const focusable = element.matches('input, select, textarea, button') ? element : element.querySelector('input, select, textarea, button');

  if (focusable && typeof focusable.focus === 'function') {
    focusable.focus({ preventScroll: true });
  }
};
